import "./App.css";
import "./fonts.css";
import { Navigate, Route, Routes, useSearchParams } from "react-router-dom";
import { BasePageLayout } from "./components/Layouts/BasePage";
import { Router } from "./router/router";
import { useDispatch } from "react-redux";
import { PageConfigActions } from "./store/PageConfigurations";
import React, { useEffect, useState } from "react";
import BookingApi from "./API/Apis/BookingApi";
import { BOOKING_ACTIONS } from "./store/onlineBooking";
import i18n from "./config/i18n";
import { BookingTextResource } from "./@types/DTO/AppSetting";
import theme, { formatTheme } from "./config/MuiColorThemes";
// import { createTheme, ThemeProvider } from "@mui/material/styles";
import createTheme from "@mui/material/styles/createTheme";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import { Logout } from "./components/UI/AppModal";

function App() {
  const dynamicPalette = formatTheme();
  const dynamicTheme = createTheme(dynamicPalette);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(PageConfigActions.setHomePageConfig({}));
    dispatch(PageConfigActions.setHeaderConfig({}));
    dispatch(PageConfigActions.setFooterConfig({}));
    BookingApi.getAppSetting().then((e) => {
      dispatch(BOOKING_ACTIONS.setAppSetting(e));
    });
    BookingApi.getTextResource().then((response) => {
      const textResource: BookingTextResource = response.data;
      dispatch(BOOKING_ACTIONS.setTextResource(textResource));
    });
  }, []);
  const [queryParams] = useSearchParams();
  useEffect(() => {
    const currentLanguage = queryParams.get("lang");
    if (currentLanguage && i18n.languages.includes(currentLanguage)) {
      i18n.changeLanguage(currentLanguage);
    }
  }, []);
  const [openLogoutConfirmation, setOpenLogoutConfirmation] = useState(false);
  const [isLogged] = useState(localStorage.getItem("isUserLoggedin"));
  const isSmallScreen = window.innerWidth <= 768;
  function getParentOrigin() {
    try {
      if (
        window.location.ancestorOrigins &&
        window.location.ancestorOrigins.length > 0
      ) {
        return window.location.ancestorOrigins[0];
      }
      if (document.referrer) {
        return new URL(document.referrer).origin;
      }
    } catch (error) {
      console.error("Error in getParentOrigin:", error);
      return "";
    }
  }
  const parentOrigin = getParentOrigin();
  const allowedOrigins = new Set([
    "https://mbrent.mercedes-benz.it",
    "https://bookingmerfina.mbrent.mercedes-benz.it",
    "https://mbrent.mercedes-benz.it/congaratulation",
    "https://merfinatestbooking.myrent.it",
    "https://mauroc147.myrent.it",
  ]);
  const targetOrigin =
    parentOrigin && allowedOrigins.has(parentOrigin) ? parentOrigin : "*";
  const showNewIFrame = (iframeFor) => {
    window.parent.postMessage(
      {
        event_id: iframeFor,
      },
      targetOrigin
    );
  };
  const scrollToTop = () => {
    window.parent.postMessage(
      {
        event_id: "scrollToTop",
      },
      targetOrigin
    );
  };

  function handleLogout() {
    BookingApi.logout();
    localStorage.setItem("isUserLoggedin", "false");
    showNewIFrame("showSignInPage");
    setOpenLogoutConfirmation(false);
  }

  const handleClose = () => {
    setOpenLogoutConfirmation(false);
  };

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data === "showSignOutConfirmation") {
        scrollToTop();
        window.scrollTo(0, 0);
        setOpenLogoutConfirmation(true);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  });

  return (
    <ThemeProvider theme={dynamicTheme || theme}>
      <BasePageLayout>
        <div>
          <Routes>
            {Router.map((el, index) => {
              let shouldRedirect = false;
              let redirectUrl = "/";
              if (el.shouldRedirect) {
                shouldRedirect = el.shouldRedirect();
              }
              if (el.redirectUrl) {
                redirectUrl = el.redirectUrl;
              }
              return (
                <Route
                  key={index}
                  path={el.path}
                  element={
                    <ProtectedRoute
                      shouldRedirect={shouldRedirect}
                      url={redirectUrl}
                      child={el.element}
                    ></ProtectedRoute>
                  }
                >
                  {el.children &&
                    el.children.map((nested, id) => {
                      return (
                        <Route
                          key={id}
                          path={nested.path}
                          element={
                            <ProtectedRoute
                              shouldRedirect={shouldRedirect}
                              url={redirectUrl}
                              child={nested.element}
                            />
                          }
                        />
                      );
                    })}
                </Route>
              );
            })}
          </Routes>
        </div>
      </BasePageLayout>
      {openLogoutConfirmation && isLogged && (
        <Logout
          open={open}
          isSmallScreen={isSmallScreen}
          handleLogout={handleLogout}
          handleClose={handleClose}
        />
      )}
    </ThemeProvider>
  );
}
interface ProtectedRouteProps {
  child: Element | JSX.Element;
  shouldRedirect: boolean;
  url: string;
  children?: any;
}

function ProtectedRoute({
  child,
  shouldRedirect,
  url = "/",
}: ProtectedRouteProps): JSX.Element {
  if (shouldRedirect) {
    return <Navigate to={url} />;
  }
  return <>{child}</>;
}
export default App;
